import React from 'react';

import MetricBox from './MetricBox';

interface BatteryStateProps {
  remaining: number; // 0..1
}

const BatteryStateOfCharge: React.FC<BatteryStateProps> = ({ remaining }) => {
  const percent = Math.round(remaining * 100);
  const color: 'normal' | 'warning' | 'danger' = remaining < 0.15 ? 'danger' : remaining < 0.3 ? 'warning' : 'normal';
  return <MetricBox label='Battery' value={`${percent}%`} color={color} />;
};

export default BatteryStateOfCharge;
